import { Component, Input, OnInit } from '@angular/core';
import { OverallSummaryData, } from "../../../../global/smartpower-types";

@Component({
    selector: 'summary-table',
    templateUrl: './summary-table.component.html',
    styleUrls: ['./summary-table.component.scss'],
    standalone: false
})
export class SummaryTableComponent implements OnInit {

  @Input() summaryData: OverallSummaryData[] = [];
  @Input() displayLoader = false;

  dates: string[] = [];

  constructor() { }

  ngOnInit(): void {}

  handleMetricPercentage(percentage: number) {
    let cellClassColor = '';

    if (percentage >= 96) {
      cellClassColor = "green-rack";
    }
    if (percentage >= 76 && percentage < 96) {
      cellClassColor =  "yellow-rack";
    }
    if (percentage < 76) {
      cellClassColor =  "red-rack";
    }

    return cellClassColor;
  }

  convertPeriodToDate(period: string) {
    const periodSplit: string[] = period.split("/");
    const monthNum: number = +periodSplit[0];
    let date = '';

    switch (monthNum) {
      case 1:
        date = `Jan-${periodSplit[1]}`;
        break;
      case 2:
        date = `Feb-${periodSplit[1]}`;
        break;
      case 3:
        date = `Mar-${periodSplit[1]}`;
        break;
      case 4:
        date = `Apr-${periodSplit[1]}`;
        break;
      case 5:
        date = `May-${periodSplit[1]}`;
        break;
      case 6:
        date = `Jun-${periodSplit[1]}`;
        break;
      case 7:
        date = `Jul-${periodSplit[1]}`;
        break;
      case 8:
        date = `Aug-${periodSplit[1]}`;
        break;
      case 9:
        date = `Sep-${periodSplit[1]}`;
        break;
      case 10:
        date = `Oct-${periodSplit[1]}`;
        break;
      case 11:
        date = `Nov-${periodSplit[1]}`;
        break;
      case 12:
        date = `Dec-${periodSplit[1]}`;
        break;
    }

    return date;
  }

}
